<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_white_card.check_out_title')">
    <template #content>
      <v-container fluid class="check-out-content">
        <v-row class="flex-grow-0">
          <v-col>
            <v-btn outlined
                   x-large
                   block
                   @click="scanForWhiteCard">
              <v-icon left>fas fa-qrcode</v-icon>
              {{ $t('admin_acc_white_card.scan_qr_code') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-container v-if="cardId"
                     fluid>
          <v-text-field readonly
                        :label="$t('admin_acc_white_card.id')"
                        :value="`A${cardId.toString().padStart(5, '0')}`"></v-text-field>

          <v-expansion-panels multiple
                              v-model="openedPanels">
            <v-expansion-panel>
              <v-expansion-panel-header>{{ $t('admin_acc_white_card.bookings') }} ({{ bookings.length }})</v-expansion-panel-header>
              <v-expansion-panel-content>
                <AdminBookingList :display-items="bookings"
                                  hide-search
                                  hide-actions></AdminBookingList>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>{{ $t('admin_acc_white_card.gym_check_ins') }} ({{ bookings.length }})</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table :items="gymCheckIns"
                              :headers="gymCheckInRecordHeaders">
                  <template v-slot:item.checkin_time="{value}">
                    {{ $parseDate(value, 'yyyy-MM-dd HH:mm:ss') }}
                  </template>
                  <template v-slot:item.checkout_time="{value}">
                    {{ $parseDate(value, 'yyyy-MM-dd HH:mm:ss') }}
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               @click="checkOut"
               class="mr-3"
               depressed
               large
               :disabled="bookings.length === 0 && gymCheckIns.length === 0">
          {{ $t('admin_acc_white_card.check_out_title') }}
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>

<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import JwtScanner from "@/components/acc_booking/JwtScanner";
import GymSubscriptionCheckInRecordList from "@/components/acc_booking/GymSubscriptionCheckInRecordList";
import AdminBookingList from "@/components/acc_booking/booking/AdminBookingList";

export default {
  name: 'CheckOutModal',
  components: {AdminBookingList, GymSubscriptionCheckInRecordList, BGModal},
  props: {
    shown: Boolean,
  },

  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          cardId.value = null;
          setTimeout(scanForWhiteCard, 500);
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    const cardId = ref(null);
    const scanForWhiteCard = async function () {
      bookings.value = [];
      gymCheckIns.value = [];
      cardId.value = await root.$dialog.showAndWait(JwtScanner, {
        title: root.$t('admin_acc_white_card.scan_qr_code'),
        targetKey: 'wht',
      });

      if (cardId.value !== undefined) {
        getWhiteCardStatus();
      }
    }

    const whiteCard = ref(null);
    const openedPanels = ref([]);
    const bookings = ref([]);
    const gymCheckIns = ref([]);
    const gymCheckInRecordHeaders = ref([
      {text: root.$t('gym_subscription.checkin_time'), value: 'checkin_time'},
      // {text: root.$t('gym_subscription.checkout_time'), value: 'checkout_time'},
      {text: root.$t('gym_subscription.type'), value: 'subscription.type.name'},
    ]);
    const getWhiteCardStatus = function () {
      root.$callAPI('aafb/admin/white_card/', {white_card_id: cardId.value}, (response) => {
        whiteCard.value = response.body.white_card;
        let idx = [];
        if (response.body.check_in_record) {
          bookings.value = response.body.check_in_record.bookings;
          if (bookings.value.length > 0) idx.push(0);
          gymCheckIns.value = response.body.check_in_record.gym_checkins;
          if (gymCheckIns.value.length > 0) idx.push(1);

          openedPanels.value = idx;
        } else {
          bookings.value = [];
          gymCheckIns.value = [];

          root.$showAlertMessage(root.$t('admin_acc_white_card.not_check_in'));
        }
      })
    }

    const checkOut = async function () {
      if (confirm(root.$t('admin_acc_white_card.check_out_confirm_msg'))) {
        root.$callAPI('aafb/admin/white_card/checkout/', {
          white_card_id: cardId.value,
        }, () => {
          root.$showAlertMessage(root.$t('admin_acc_white_card.check_out_success_msg'));
          cancel()
        });
      }
    };


    return {
      dialogShown,
      cancel,

      cardId,
      scanForWhiteCard,

      whiteCard,
      openedPanels,
      bookings,
      gymCheckIns,
      gymCheckInRecordHeaders,

      checkOut,
    }
  }
}
</script>
